
const key = "QUOTATIONS"

export const QUOTATIONS = {
        CLEAR: `${key}_CLEAR_QUOTATIONS_STORE`,
};
